exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modalEvidencia,\n.modalEnvio {\n  position: fixed;\n  z-index: 1;\n  padding-top: 100px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.modalEvidencia-content,\n.modalEnvio-content {\n  background-color: #fafafa;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n}\n.modalEnvio-content {\n  min-width: 300px;\n  max-width: 500px;\n  width: 30%;\n}\n", ""]);

// exports
